"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _ProfileIntegrationsActionsList = _interopRequireDefault(require("crm_ui/profile/sidebar/integrations/actions/ProfileIntegrationsActionsList"));

var _ProfileIntegrationsAction = _interopRequireDefault(require("crm_ui/profile/sidebar/integrations/actions/ProfileIntegrationsAction"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _default = (0, _createReactClass.default)({
  displayName: 'ProfileIntegrationsLinkedSalesObjectFooter',
  propTypes: {
    applicationId: _propTypes.default.number.isRequired,
    appName: _propTypes.default.string.isRequired,
    associatedObjectId: _propTypes.default.number.isRequired,
    associatedObjectType: _propTypes.default.oneOf([_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL]).isRequired,
    closeIframeModal: _propTypes.default.func.isRequired,
    iframeParentTitle: _propTypes.default.string.isRequired,
    linkedSalesObject: _reactImmutableProptypes.default.map,
    linkedSalesObjectContent: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    objectTypeId: _propTypes.default.number.isRequired,
    openIframeModal: _propTypes.default.func.isRequired
  },
  renderPrimaryAction: function renderPrimaryAction() {
    var primaryAction = this.props.linkedSalesObjectContent.getIn(['content', 'primaryAction']);

    if (!primaryAction) {
      return null;
    }

    return _react.default.createElement(_ProfileIntegrationsAction.default, (0, _extends2.default)({}, this.props, {
      action: primaryAction,
      buttonClassName: "integrations-primary-action",
      buttonUse: "tertiary-light",
      buttonSize: "small"
    }));
  },
  renderSecondaryActions: function renderSecondaryActions() {
    var secondaryActions = this.props.linkedSalesObjectContent.getIn(['content', 'secondaryActions']);

    if (!secondaryActions.size) {
      return null;
    }

    return _react.default.createElement(_ProfileIntegrationsActionsList.default, (0, _extends2.default)({}, this.props, {
      actions: secondaryActions,
      buttonText: _I18n.default.text('profileSidebarModule.integrations.actions'),
      buttonUse: "tertiary-light",
      buttonSize: "small",
      dropdownButtonUse: "link",
      iconName: null
    }));
  },
  renderActionButtons: function renderActionButtons() {
    var content = this.props.linkedSalesObjectContent.get('content');

    if (!content || !content.has('primaryAction') && !(content.get('secondaryActions') && content.get('secondaryActions').size) && !content.has('settingsAction')) {
      return null;
    }

    return _react.default.createElement(_UISection.default, {
      className: "text-center m-bottom-10"
    }, this.renderPrimaryAction(), this.renderSecondaryActions());
  },
  renderPoweredByIcon: function renderPoweredByIcon() {
    var linkedSalesObject = this.props.linkedSalesObject;
    var poweredByIconUri = linkedSalesObject.get('iconUri') || linkedSalesObject.get('singleColorIconUri');

    if (!poweredByIconUri) {
      return null;
    }

    return _react.default.createElement(_UIImage.default, {
      src: poweredByIconUri,
      className: "m-right-1",
      alt: _I18n.default.text('profileSidebarModule.integrations.poweredByLogoAlt', {
        appName: linkedSalesObject.get('appName')
      }),
      width: 30
    });
  },
  renderPoweredBy: function renderPoweredBy() {
    var linkedSalesObject = this.props.linkedSalesObject;
    return _react.default.createElement("div", {
      className: "flex-row align-center"
    }, this.renderPoweredByIcon(), _react.default.createElement(_Small.default, {
      use: "help"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "profileSidebarModule.integrations.poweredBy",
      options: {
        appName: linkedSalesObject.get('appName')
      }
    })));
  },
  renderSettingsAction: function renderSettingsAction() {
    var linkedSalesObjectContent = this.props.linkedSalesObjectContent;
    var settingsAction = linkedSalesObjectContent.getIn(['content', 'settingsAction']);

    if (!settingsAction) {
      return null;
    }

    return _react.default.createElement(_ProfileIntegrationsAction.default, (0, _extends2.default)({}, this.props, {
      action: settingsAction,
      buttonSize: "small",
      buttonUse: "link"
    }));
  },
  renderPoweredByAndSettings: function renderPoweredByAndSettings() {
    return _react.default.createElement(_UISection.default, {
      className: "m-bottom-0"
    }, _react.default.createElement(_UIList.default, {
      inline: true,
      use: "inline-divided"
    }, this.renderPoweredBy(), this.renderSettingsAction()));
  },
  render: function render() {
    return _react.default.createElement("div", null, this.renderActionButtons(), this.renderPoweredByAndSettings());
  }
});

exports.default = _default;
module.exports = exports.default;